module.exports = __webpack_public_path__ + "static/media/usage-rules.3efa7bcc.pdf";